import CarMap from '../../car/info/map'
import CompanyMap from '../../company/info/map'
import City from './partial/city'

import './index.less'

const city = [
  {name:'长沙',code:'430100'},
  {name:'西安',code:'610100'},
  {name:'合肥',code:'340100'},
  {name:'杭州',code:'330100'},
  {name:'绍兴',code:'330600'},
  {name:'重庆',code:'500000'},
  {name:'莆田',code:'350300'},
  {name:'泉州',code:'350500'},

]
// 22659
export default {
  props:{
    slient:{
      type:Boolean,
      default:false
    },
    defaultAreacode:{
      type:Number,
    }
  },
  data(){
    return {
      companyId:null,
      carNo:null,
      areacode:'86',
      zoom:11,
      radius:100000,
      showCar:false,
      disableClusterCount:true,

    }
  },
  created() {
    if (this.$route.query.focusCompanyId) {
      this.companyId = this.$route.query.focusCompanyId
    }

    if (this.$route.query.focusCarNo) {
      this.carNo = this.$route.query.focusCarNo
    }

    if (this.$route.query.zoom) {
      this.zoom = this.$route.query.zoom
    }

    if(this.$route.query.enableClusterCount){
      this.disableClusterCount = false
    }

    this.areacode = this.defaultAreacode || this.$route.query.areacode
    this.showCar = this.$route.query.type == 'car'
    if( this.$route.query.radius ){
      this.radius = parseInt(this.$route.query.radius)
    }

    window.setType = parent.window.setType = (type) => {
      this.showCar = type == 'car'
    }
    
  },
  methods:{
    handleToggle(){
      this.companyId = null
      this.carNo = null
      this.showCar = !this.showCar
    },
    handleClose(){
      if(window.parent.hideModal){
        window.parent.hideModal()
      }
    },
    handleChangeCity(code){
      if( this.areacode == code ){
        if( code == 86 ){
          if( this.showCar ){
            this.$refs['carmap'].changeArea(86)
          }else{
            this.$refs['companymap'].changeCity(86)
          }
        }
        
      }else{
        this.areacode = code
      }
    }
  },
  render(){
    return <div class="screen">
      {
        this.showCar ? 
          <CarMap disableClusterCount={this.disableClusterCount} ref="carmap" defaultAreaCode={this.areacode} defaultVisibleCount={true} defaultRadius={this.radius} defaultZoom={this.zoom} defaultCarNo={this.carNo} style="position: absolute;height:100%;" /> : 
          <CompanyMap disableClusterCount={this.disableClusterCount} ref="companymap" defaultAreaCode={this.areacode} defaultZoom={this.zoom} default-id={this.companyId} style="position: absolute;height:100%;" />
      }
      
      <div class="screen__menu" style="">
        {
          this.slient ? null : <div on-click={this.handleClose} class="screen__menu-item"><Icon type="ios-arrow-back" style="margin-right:6px" size={15} />返回大屏</div> 
        }
        
        <div on-click={this.handleToggle} class="screen__menu-item screen__menu-item--last">
          <Icon size={15} style="margin-right:6px" custom={this.showCar ? 'i-icon icon-company' : 'i-icon icon-car'}></Icon>
          {this.showCar ? '网点地图' : '车辆地图'}</div>
      </div>

      <div class="screen__shortcut">
        <City areacode={this.areacode} on-change={this.handleChangeCity} showCar={this.showCar} city={city} />
      </div>
    </div>
  }
}